import React from "react";
import { Link } from "react-router-dom";

const NavBar = () => {
  return (
    <div className="NavBar m-4 d-flex justify-content-center">
      <div
        className="btn-group"
        role="group"
        aria-label="Button group with nested dropdown"
      >
        <Link to="/">
          <button type="button" className="btn btn-info">
            🏠
          </button>
        </Link>

        <div className="btn-group" role="group">
          <button
            id="btnGroupDrop1"
            type="button"
            className="btn btn-light dropdown-toggle border"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Toolkit 🧰
          </button>
          <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
            <Link className="dropdown-item" to="/connection-builder">
              Connection Builder 🔗
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
